import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import type { BusinessUnitCode } from '~/model'

const defaultLanguages = ['nl', 'en', 'de', 'es', 'fr', 'it']

const languagesByBusinessUnit: Record<BusinessUnitCode, string[]> = {
  'dhl-nl': defaultLanguages,
  'dhl-be': ['nl', 'fr', 'en', 'de', 'es', 'it'],
  ccc: ['en', 'de', 'fr', 'nl', 'es', 'it'],
}

export const languageForBusinessUnit = (businessUnitCode: BusinessUnitCode): string[] =>
  languagesByBusinessUnit[businessUnitCode] ?? defaultLanguages

export const i18n = i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    backend: {
      loadPath: (languages: string[]) => {
        const currentLanguage = languages[0]
        return `/return-portal/i18n/${currentLanguage}.json`
      },
    },
    saveMissing: false,
    debug: false,
    supportedLngs: defaultLanguages,
    detection: {
      order: ['navigator', 'querystring', 'cookie', 'localStorage', 'sessionStorage'],
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })
  .then(() => {})
